import { Anchored } from "./anchored.js";
import { Slot } from "./slot.js";
/**
 * {@link https://html.spec.whatwg.org/#concept-column}
 *
 * @public
 */
export class Column {
    static of(x) {
        return new Column(x);
    }
    _x;
    constructor(x) {
        this._x = x;
    }
    get x() {
        return this._x;
    }
    get anchor() {
        return Slot.of(this._x, 0);
    }
    compare(anchored) {
        return Anchored.compare(this, anchored);
    }
    equals(value) {
        return value instanceof Column && value._x === this._x;
    }
    toJSON() {
        return {
            x: this._x,
        };
    }
}
/**
 * @public
 */
(function (Column) {
    function isColumn(value) {
        return value instanceof Column;
    }
    Column.isColumn = isColumn;
    /**
     * {@link https://html.spec.whatwg.org/#concept-column-group}
     */
    class Group {
        static of(element, x, width) {
            return new Group(element, x, width);
        }
        _element;
        _x;
        _width;
        constructor(element, x, width) {
            this._element = element;
            this._x = x;
            this._width = width;
        }
        get element() {
            return this._element;
        }
        get x() {
            return this._x;
        }
        get anchor() {
            return Slot.of(this._x, 0);
        }
        get width() {
            return this._width;
        }
        compare(anchored) {
            return Anchored.compare(this, anchored);
        }
        equals(value) {
            return (value instanceof Group &&
                value._element.equals(this._element) &&
                value._x === this._x &&
                value._width === this._width);
        }
        toJSON() {
            return {
                element: this._element.path(),
                x: this._x,
                width: this._width,
            };
        }
    }
    Column.Group = Group;
    (function (Group) {
        function isGroup(value) {
            return value instanceof Group;
        }
        Group.isGroup = isGroup;
    })(Group = Column.Group || (Column.Group = {}));
    Column.group = Group.of, Column.isGroup = Group.isGroup;
})(Column || (Column = {}));
//# sourceMappingURL=column.js.map